import { getPlaceholder } from "../../../utils/TokenSelector/utils";
import styled from "@emotion/styled";
import { CounterParty } from "../../../utils/tradeUtils";
import { forwardRef } from "react";
import { Hash } from "viem";

interface TokenSelectorInputProps {
  counterParty: CounterParty;
  isDropdownDisplayed: boolean;
  setIsDropdownDisplayed: React.Dispatch<React.SetStateAction<boolean>>;
  currentPartyTokens: Array<Hash>;
  searchString: string;
  setSearchString: React.Dispatch<React.SetStateAction<string>>;
}

export const TokenSelectorInput = forwardRef<HTMLInputElement, TokenSelectorInputProps>(
  (
    {
      counterParty,
      isDropdownDisplayed,
      setIsDropdownDisplayed,
      currentPartyTokens,
      searchString,
      setSearchString,
    },
    ref
  ) => {
    return (
      <Input
        spellCheck={false}
        placeholder={getPlaceholder(
          counterParty,
          isDropdownDisplayed,
          currentPartyTokens.length < 1
        )}
        value={searchString}
        onChange={e => setSearchString(e.target.value)}
        onBlur={() => setSearchString(s => s.trim())}
        onFocus={() => !isDropdownDisplayed && setIsDropdownDisplayed(true)}
        onClick={() => !isDropdownDisplayed && setIsDropdownDisplayed(true)}
        maxLength={100}
        ref={ref}
      />
    );
  }
);

const Input = styled.input`
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: none;
  border: none;
  line-height: 1.4;
  color: ${props => props.theme.font.primary.default};
  max-width: 90%;
  text-overflow: ellipsis;
  font: ${props => props.theme["Desktop"].Title.Medium};
  padding: 0;
  outline: none;
  font &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${props => props.theme.font.tertiary.default};
  }
`;
